<template>
  <mf-card-container title="Faturamento anual">
    <mf-loading :boolean-loader="loading" loader-type="chart">
      <v-card-text>
        <line-chart v-if="listaMensal && listaMensal.length" :chart-data="chartData" :options="chartConfig" />
        <v-container v-else class="my-6">
          <v-row align="center">
            <v-col align="center">
              <span class="subtitle">Nenhum resultado encontrado</span>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </mf-loading>
  </mf-card-container>
</template>

<script>
import { groupBy, orderBy } from 'lodash'
import LineChart from '@/components/LineChart.vue'
import { colors } from '@/config/colors.js'
import { localeString } from '@/config/helpers.js'

export default {
  components: {
    LineChart,
  },
  props: {
    listaMensal: Array,
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    chartData() {
      const chartData = {
        labels: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        datasets: [],
      }
      const arrayAgrupado = groupBy(orderBy(this.listaMensal, 'NUM_MES'), 'NUM_ANO')

      Object.keys(arrayAgrupado).forEach((key, index) => {
        let indiceAtual = 0
        const data = []
        for (let i = 1; i <= 12; i++) {
          if (i === arrayAgrupado[key][indiceAtual]?.NUM_MES) {
            data.push(arrayAgrupado[key][indiceAtual]['VAL_FATURAMENTO'])
            indiceAtual++
          } else {
            data.push(undefined)
          }
        }

        chartData.datasets.push({
          label: arrayAgrupado[key][0]['NUM_ANO'],
          backgroundColor: colors[index],
          strokeColor: colors[index],
          borderColor: colors[index],
          fill: false,
          data: data,
          datalabels: { display: false },
        })
      })
      return chartData
    },
    chartConfig() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        elements: {
          line: {
            tension: 0,
          },
          point: {
            radius: 1,
          },
        },
        animation: {
          duration: 0,
        },
        hover: {
          animationDuration: 0,
        },
        responsiveAnimationDuration: 0,
        legend: {
          display: true,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: (value) => `R$ ${localeString(value, 2)}`,
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: { display: false },
            },
          ],
        },
        tooltips: {
          mode: 'index',
          intersect: false,
          callbacks: {
            label: (tooltip) => {
              return 'R$ ' + localeString(tooltip.yLabel, 2)
            },
          },
        },
      }
    },
  },
}
</script>
